import { Generator } from "../../FileToolbar/GenerateCodeItem/types/generator";
import { BehaviorSubject } from "rxjs";
import { GeneratorOptions } from "../../FileToolbar/GenerateCodeItem/json/generator-options";
import { GenModel } from "../../FileToolbar/GenerateCodeItem/types/generator";
import { getStatechart } from "../model-helper";
import { RappidContext } from "../../../../index";
import { camelCase } from "lodash-es";

export const DEFAULT_GENERATOR: Generator = GeneratorOptions[0];

export default class GeneratorModelState {
  /* eslint-disable @typescript-eslint/no-explicit-any*/
  observable: BehaviorSubject<GenModel>;
  type = "create::c";

  constructor(private rappidContext: RappidContext) {
    this.observable = new BehaviorSubject<GenModel>(this.createEmptyGeneratorModel());
  }

  createEmptyGeneratorModel(type = "create::c"): GenModel {
    this.type = type;
    const genModel: any = { generator: { type: this.type, features: {} } };
    const genOption = this.getGeneratorOption(this.type);
    const title = getStatechart(this.rappidContext.paper.model)?.getName() ?? "myStatechart";
    const titleCamelCase = camelCase(title);
    genOption.statechart = titleCamelCase;
    for (const type of genOption.features) {
      const featureName = type.name;
      genModel.generator.features[featureName] = {};
      for (const param of type.parameters) {
        if (param.type.includes("string")) {
          switch (param.name) {
            case "sourceFilenameExtension":
              genModel.generator.features[featureName][param.name] = this.type.substring(
                this.type.indexOf(":") + 2,
                this.type.length
              );
              break;
            case "headerFilenameExtension":
              genModel.generator.features[featureName][param.name] = "h";
              break;
            case "separator":
              genModel.generator.features[featureName][param.name] = "_";
              break;
            case "statemachinePrefix":
              // camelCase
              genModel.generator.features[featureName][param.name] = titleCamelCase;
              break;
            case "moduleName":
            case "typeName":
              // PascalCase
              genModel.generator.features[featureName][param.name] =
                titleCamelCase[0].toUpperCase() + titleCamelCase.slice(1);
              break;
            case "metaSource":
              genModel.generator.features[featureName][param.name] = "private";
              break;
            case "libraryPackage":
              genModel.generator.features[featureName][param.name] = "com.create.core";
              break;
            default:
              genModel.generator.features[featureName][param.name] = "";
          }
        } else {
          genModel.generator.features[featureName][param.name] = false;
        }
      }
    }
    return genModel;
  }

  updateTitleRelatedVals(genModel: GenModel, newTitle: string): GenModel {
    const titleCamelCase = camelCase(newTitle);
    const genModelNew = JSON.parse(JSON.stringify(genModel));
    for (const feature in genModel.generator.features) {
      if (genModel.generator.features[feature]["statemachinePrefix"]) {
        genModelNew.generator.features[feature]["statemachinePrefix"] = titleCamelCase;
      }
      if (genModel.generator.features[feature]["typeName"]) {
        genModelNew.generator.features[feature]["typeName"] = titleCamelCase[0].toUpperCase() + titleCamelCase.slice(1);
      }
      if (genModel.generator.features[feature]["moduleName"]) {
        genModelNew.generator.features[feature]["moduleName"] =
          titleCamelCase[0].toUpperCase() + titleCamelCase.slice(1);
      }
    }
    return genModelNew;
  }

  prepareModelForPost(genModel: GenModel): string {
    const model: any = { generator: { type: this.type, features: {} } };
    const genOption = this.getGeneratorOption(this.type);
    for (const type of genOption.features) {
      const featureName = type.name;
      model.generator.features[featureName] = {};
      for (const param of type.parameters) {
        if (param.type.includes("string")) {
          if (genModel.generator.features[featureName][param.name].trim() !== "" && param.name !== "basePackage") {
            model.generator.features[featureName][param.name] = genModel.generator.features[featureName][param.name];
          }
        } else if (genModel.generator.features[featureName][param.name]) {
          model.generator.features[featureName][param.name] = genModel.generator.features[featureName][param.name];
        }
      }
    }
    return JSON.stringify(model, null, 2);
  }

  setEmptyGeneratorModel(type = "create::c"): GenModel {
    const genModel = this.createEmptyGeneratorModel(type);
    this.setGeneratorModel(genModel);
    return genModel;
  }

  getGeneratorOption(type: string): Generator {
    return GeneratorOptions.find((el) => el.type === type);
  }

  setGeneratorModel(genModel: GenModel): void {
    this.observable.next(genModel);
  }

  resetGeneratorModel(): void {
    this.observable.unsubscribe();
    this.observable = new BehaviorSubject<GenModel>(this.createEmptyGeneratorModel());
  }

  getGeneratorModel(): GenModel {
    return this.observable.value;
  }
  /* eslint-enable @typescript-eslint/no-explicit-any*/
}
